import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import './style.scss';

const Tips: React.FC = () => {
    return (
        <div className="upgrade-password-tips-root">
            <div className="tips-header">
                {__('为保护您的账号安全，您需要更新登录密码。更新成功后需重新登录生效。')}
            </div>
            <div className="desc">
                {__('系统自动判断您此次需要更新密码的原因可能为:')}
                <ul>
                    <li>1. {__('长时间未更新登录密码；')}</li>
                    <li>2. {__('在多台设备或不同地点的网络环境中有过登录行为的系统记录；')}</li>
                    <li>3. {__('现有登录密码安全强度弱')}</li>
                </ul>
            </div>
            <CardButtonWrap>
                <Link to="../1" className="w-100">
                    <Button block type="primary" size="large">
                        {__('立即更新')}
                    </Button>
                </Link>
            </CardButtonWrap>
        </div>
    );
};

export default Tips;
